export default __webpack_public_path__ + "img/introduce.5d975353.png";